<template>
  <div>
    <div class="up">
      <div class="title container">
        <h1 class="main-title">说服老板--为什么来ArchSummit</h1>
        <div class="subtitle">/一颗好学之心鞭策着我，使我进步、提升！/</div>
        <div class="line">
          <div class="triangle"></div>
        </div>
      </div>
      <div class="content container">
        <div class="wrapper">
          <p>
            你从来都没放弃过继续学习和进步，你会看很多专业的书籍，在GitHub参考别人的实现方法，跟团队的小伙伴热烈的讨论；在深夜一杯咖啡到天明也不觉得疲惫......
          </p>
          <p>
            有时候也会困惑，也会有很多无法自己解决的问题，很复杂的实现原理让你的效率变低，甚至有些无解的问题让你怀疑自己的水平是否真的就仅仅是一个平庸的程序员。
          </p>
          <p>
             但实际上可能是：<b style="color: #1f63af;font-size: 16px">你的技术认知还可以再提升一点。</b>
          </p>
          <p>相信看到这个页面的你对 InfoQ 举办的 ArchSummit 全球架构师峰会也有一定的了解，甚至已经迫不及待地想和上百位国内外技术大牛、千余名技术同行共同切磋琢磨过去落地与未来计划的一系列技术实践。
          </p>

           <p>但现在你可能遇到了一个棘手的问题：<b style="color: #1f63af;font-size: 16px">能否和所在企业申请报销你的行程及其他开销？</b></p>
           <p>试试吧！你完全可以轻松说服你的老板！因为参加 ArchSummit 不仅有利于你的个人成长，同样也能帮助你整个技术团队乃至部门，我们为你列出了参加 ArchSummit 可以为你公司带来的回报：</p>
           <p class="font-weight">
             <span>你会遇到很多像你一样优秀的开发者，通过这100+场大会演讲，收获很多全新的开发思路/技巧/灵感；</span>
             <span>
               当你回去工作的时候会有更清晰整体的研发思路，因为你的思维已经焕然一新并且有了全新动力；
             </span>
             <span>当你和你的团队进行头脑风暴来寻找灵感的时候，你有更多的好故事和相关案例；</span>
             <span>会议的所有演讲视频可以无限重复播放复习；</span>
             <span>参加完大会后，你会变得充满信心和斗志、开心、有效率；</span>
             <span>欢迎联系票务经理灰灰，电话：+86-15600537884，微信：15600537884 / aschina666。</span>
           </p>
        </div>
      </div>
    </div>
    <div class="down">
      <div class="title container down-title">
        <h1 class="main-title">一封写给老板的邮件</h1>
        <div class="subtitle">/一颗好学之心鞭策着我，使我进步、提升！/</div>
        <div class="line down-line">
          <div class="triangle triangle-down"></div>
        </div>
        <div class="tab">
          <div class="wrapper">
            <span class="word" @click="switchTab('zh')" :class="{'active': active==='zh'}">中文邮件</span>
            <span class="middle-line"></span>
            <span class="word" @click="switchTab('en')" :class="{'active': active==='en'}">ENGLISH</span>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="wrapper" v-if="active === 'zh'">
          <p>
            Hi Boss！
          </p>
          <p>
            近几年，架构在软件研发领域的重要意义愈加显现，了解了系统架构，才能够真正把握项目整体大局，使设计的项目尽量高效易行，维护方便，升级简单。诸如Google、腾讯、百度、阿里这样的名企大厂在架构领域的新实践，对于我们的系统研发和技术落地，都具有重要的指导和借鉴意义。
          </p>
          <p>
            我相信，了解同行的最新技术落地实践，学习各个领域的架构应用模式，对于我们的技术团队、部门乃至公司都将产生巨大的价值：可以优化我们的整体架构思路，寻找解决痛点的最优解，降低成本，创造收益！
          </p>
          <p>
            因此我希望能够为我们团队申请报名 ArchSummit 全球架构师峰会。
          </p>
          <p>
            ArchSummit 全球架构师峰会是 InfoQ 中国团队推出的重点面向高端技术管理者、架构师的技术会议，54%参会者拥有8年以上工作经验。它聚焦业界强大的技术成果，秉承“实践第一、案例为主”的原则，展示先进技术在行业中的典型实践，旨在帮助技术管理者、CTO、架构师做好技术选型、技术团队组建与管理，并确立技术对于产品和业务的关键作用。
          </p>
          <p>
            大会到目前已经成功举办了12届，每届都邀请来自微软、Google、LinkedIn、Netflix、BAT等的名企专家进行实践案例的分享，受益面达到数十万人。（详情参考2018年北京站官网： <a
            href="https://bj2018.archsummit.com/schedule">https://bj2018.archsummit.com/schedule</a> ）
          </p>

           <p>目前， ArchSummit 策划了诸多与我们密切相关的话题，届时会有超过100位的国内外技术大牛进行经验分享，一千余名技术同行参会。</p>
           <p>我们对XXX策划的YYYY专题，以及XXX讲师带来的分享十分感兴趣，也期待现场能够和这些国内外的技术大牛们现场沟通交流，并建立起长久的联系，也相信届时会迸发出更多思考和灵感，并减少未来在开发上的弯路。</p>
           <p>我相信我们公司将从本次参会中获得：</p>
           <p>
             <span>了解更多优秀公司的技术实践及思路；</span>
             <span>找到适合我们公司和团队应用、并且有助于提升产品及服务的解决方案；</span>
             <span>跟业界更多优秀的同行会面交流，得到启发；</span>
             <span>充实的大会学习可以使我们整理自己的情绪状态，以更饱满积极的状态投入到之后的工作中。</span>
           </p>
           <p v-if="data.showDiscount">
             <span v-if="Number(discount.discount)!==10">另外，如果现在报名，我们还能够享受最为优惠的{{discount.discount}}折折扣，能够每人节省{{discount.discountPrice}}元。</span>
             <b style="color: red">5人和10人以上一起参会，还能有更大优惠。</b>
           </p>
           <p>您可以在 ArchSummit官网：<a :href="origin">{{origin}}</a> 了解这场峰会的进一步信息。</p>
           <p>
             妥否请批，盼复为谢！
          </p>
          <p style="text-align: right;color: red">渴望学习和交流的技术团队</p>
          <p>
            <span>P.S.：</span>
            <span>峰会官网：<a :href="`${origin}/`">{{`${origin}/`}}</a></span>
            <span>报名链接：<a :href="`${origin}/apply`">{{`${origin}/apply`}}</a></span>
            <span>时间：{{`${conTimeInfo.beginTime}-${conTimeInfo.endTime}`}}</span>
            <!-- <span>培训：{{`${conTimeInfo.beginTimeTraining}-${conTimeInfo.endTimeTraining}`}}（北京·五洲皇冠国际酒店）</span> -->
            <span>地址：{{address.name}}</span>
          </p>
        </div>
        <div class="wrapper" v-if="active === 'en'">
          <p>
            Apply to attend the top technology conference ArchSummit {{enName}}
          </p>
          <p>
            Dear (NAME),<br/>
            I would like your approval to attend ArchSummit ( {{enName}} ), which is held at the <b style="color:red;font-weight: 400;">{{enLocation}}</b>, on {{enTime}}
          </p>
          <p>
            ArchSummit is an international technology conference organized by the InfoQ China team, which is focused on high-end technology managers and architects. More than 100 speakers from well-known companies （ like Google, Microsoft, Alibaba, Baidu, Tencent, etc. ) will bring  new ideas, driving innovations, and adopting  technologies which are inside of their companies. Besides, according to the law of attraction, this conference absorbs over 1000 attendees who are influential, inspiring in Internet technology field. 50% of the participants have more than 8 years of working experience.
          </p>
          <p>
            I am firmly convinced that participating in ArchSummit will give me direct access to cases and practical experience in technologies we use on a daily basis which will be  intended to adopt in the future. ArchSummit focuses on the advanced technical achievements of the industry, adhering to the principle of “practice first, case-based” and demonstrating the best practices of advanced technologies in the industry.
          </p>
          <p>
            <b style="color:red;font-weight: 400;">Highlights:</b>
          </p>
          <ul>
            <li>100+ experts from companies like Google, Microsoft, Alibaba, Baidu, Tencent;</li>
            <li>20+ topics are curated and handpicked by a committee of top engineering thought leaders;</li>
            <!-- <li>In addition to the two days of technical content, ArchSummit offers two additional days of deep, real-world workshops;</li> -->
            <li>I will have access to first-hand information of the most relevant technologies, in addition to knowing how other companies are using languages and architectures in the best way. This will facilitate our adoption of these techniques and technologies;</li>
            <li>While attending I will also have the opportunity to meet and network with my most important peers in the industry.</li>
          </ul>
          <p>You can find more details of ArchSummit at <a :href="origin">{{origin}}</a>;</p>
          <p>If I am able to attend ArchSummit, I would then like to present a summary of my experience, recommendations and findings to our team.</p>
          <p>Thank you for your consideration!</p>
          <p>[YOUR NAME]</p>
        </div>
        <div class="container btn-wrapper">
          <com-btn>
            <a href="Mailto:example@xx.xx" class="btn" @click="ga">立即给Boss发邮件</a>
          </com-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import comBtn from '@/components/com-button'
import moment from 'moment'
import util from '@/utils'
export default {
  data () {
    return {
      active: 'zh'
    }
  },
  components: {
    comBtn
  },
  methods: {
    switchTab (idx) {
      this.active = idx
    },
    ga () {
      util.GA('send', 'event', 'qconbj2018说服老板', '点击次数')
    }
  },
  computed: {
    enName () {
      return this.$store.state.comConfig.location.EN
    },
    enTime () {
      let beginT = moment(this.$store.state.info.beginTime)
      let endT = moment(this.$store.state.info.endTime)
      return `${beginT.format('MMM D')}th-${endT.format('D')}th,${beginT.format('YYYY')}`
    },
    enLocation () {
      return this.$store.state.info.address.nameEn
    },
    data () {
      return this.$store.state.info.btnApply
    },
    price () {
      return this.$store.state.info.price
    },
    discount () {
      if (!this.data.showDiscount) return false
      for (let i = 0; i < this.price.discount.length; i++) {
        let d = this.price.discount[i]
        let cur = moment()
        let end = moment(d.end)
        if (!cur.isAfter(end)) {
          let remainDays = moment(end).diff(cur, 'days') + 1
          let discountPrice = (this.price.price - d.price) / 100
          let discount = d.discount
          return { remainDays, discountPrice, discount }
        }
      }
      return false
    },
    origin () {
      return window.location.origin
    },
    contact () {
      let contact = { book: '', email: '', consultation: '' }
      this.$store.state.info.contacts.forEach(c => {
        if (!c.key) c.key = 'none'
        contact[c.key] = c
      })
      return contact
    },
    address () {
      return this.$store.state.info.address || ''
    },
    conTimeInfo () {
      let conTimeInfo = {
        beginTime: '',
        endTime: '',
        beginTimeTraining: '',
        endTimeTraining: ''
      }
      if (this.$store.state.info.beginTime) {
        conTimeInfo.beginTime = moment(this.$store.state.info.beginTime).utcOffset('+08:00').format('YYYY年MM月DD')
      }
      if (this.$store.state.info.endTime) {
        conTimeInfo.endTime = moment(this.$store.state.info.endTime).utcOffset('+08:00').format('DD日')
      }
      if (this.$store.state.info.beginTime && this.$store.state.info.endTime) {
        let beginTimeFormat = moment(this.$store.state.info.beginTime).utcOffset('+08:00').format('YYYY-MM-DD')
        let endTimeFormat = moment(this.$store.state.info.endTime).utcOffset('+08:00').format('YYYY-MM-DD')
        conTimeInfo.duringCon = Math.floor(Math.abs((Date.parse(endTimeFormat) - Date.parse(beginTimeFormat)))) / (24 * 3600 * 1000) + 1
      }
      if (this.$store.state.info.beginTimeTraining) {
        conTimeInfo.beginTimeTraining = moment(this.$store.state.info.beginTimeTraining).utcOffset('+08:00').format('YYYY年MM月DD')
      }
      if (this.$store.state.info.endTimeTraining) {
        conTimeInfo.endTimeTraining = moment(this.$store.state.info.endTimeTraining).utcOffset('+08:00').format('DD日')
      }
      if (this.$store.state.info.beginTime && this.$store.state.info.endTime) {
        let beginTimeTrainingFormat = moment(this.$store.state.info.beginTimeTraining).utcOffset('+08:00').format('YYYY-MM-DD')
        let endTimeTrainingFormat = moment(this.$store.state.info.endTimeTraining).utcOffset('+08:00').format('YYYY-MM-DD')
        conTimeInfo.duringTraining = Math.floor(Math.abs((Date.parse(endTimeTrainingFormat) - Date.parse(beginTimeTrainingFormat)))) / (24 * 3600 * 1000) + 1
      }
      return conTimeInfo
    }
  }
}
</script>
<style scoped lang='sass'>
@import "../../style/variable"

a:hover
  color: #1f63af

.btn-wrapper
  display: flex
  justify-content: center
  margin-top: 20px
  span
    width: 220px
    height: 50px
    .btn
      color: #fff
      &:hover
        color: #fff

.title
  text-align: center
  padding: 75px 0 60px
  &.down-title
    padding-bottom: 0
  h1
    font-size: 40px
    font-weight: 700
    letter-spacing: 5px
  .subtitle
    font-size: 14px
    color: #888
    letter-spacing: 12px
  .line
    border-top: 1px solid #e0e0e0
    display: flex
    justify-content: center
    margin-top: 30px
    &.down-line
      margin: 30px 0
    .triangle
      border-bottom: 1px solid #e0e0e0
      border-left: 1px solid #e0e0e0
      width: 28px
      height: 28px
      background-color: #f5f5f5
      transform: translateY(-14px) rotate(-45deg)
      &.triangle-down
       background-color: #fff
.tab
  display: flex
  justify-content: center
  margin-left: 4px
  .wrapper
    margin: 0 auto
    display: inline-block
    .word
      padding: 0 4px
      cursor: pointer
      transition: all 0.3s linear
      &.active
        color: #5399e0
      &:hover
        color: #5399e0
    .middle-line
      display: inline-block
      width: 1px
      height: 12px
      background-color: #000

.up
  background: url('https://static.geekbang.org/infoq/5a7fcb58cbf38.png?imageView2/0/') no-repeat top
  background-size: cover
  height: 965px
  .content
    box-shadow: 0 4px 20px 0 rgba(7,17,27,.1)
    margin-top: -15px
    .wrapper
      background: url('https://static.geekbang.org/infoq/5a7fdc764b28e.png?imageView2/0/')
      background-size: cover
      height: 596px
      width: 100%
      margin: 0 auto
      padding: 50px 70px
      font-size: 14px
      span
        display: block
      .font-weight
        font-weight: 700
        font-size: 16px

.down
  background-size: contain
  height: 1674px
  .content
    background: url('https://static.geekbang.org/infoq/5c1c5a4c7607e.png') no-repeat top
    background-size: contain
    height: 1420px
    .wrapper
      width: 800px
      margin: 0 auto
      padding-top: 100px
      font-size: 14px
      span
        display: block
  @media screen and (max-width: 1326px)
    .content
        background-size: cover
</style>
